import { combineReducers } from 'redux';
import * as constants from './actions';

export const COUNTRY = 'COUNTRY';
export const CLUSTER = 'CB_CLUSTER';
export const AREA = 'CB_AREA';
export const THANA = 'CB_THANA';

const selectedState = (state = null, action) => {
  switch (action.type) {
    case constants.FETCH_CB_COUNTRY_DETAILS_SUCCESS:
      return COUNTRY;
    case constants.FETCH_CB_CLUSTER_DETAILS_SUCCESS:
      return CLUSTER;
    case constants.FETCH_CB_AREA_DETAILS_SUCCESS:
      return AREA;
    case constants.FETCH_CB_THANA_DETAILS_SUCCESS:
      return THANA;
    default:
      return state;
  }
};

const filteringState = (
  state = constants.INIT_PARTNER_REPORTS_FILTER_STATE || {},
  action
) => {
  switch (action.type) {
    case constants.CHANGE_FILTERING_STATE:
      return action.payload;
    default:
      return state;
  }
};

const countryDetails = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_CB_COUNTRY_DETAILS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const clusterDetails = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_CB_CLUSTER_DETAILS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const areaDetails = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_CB_AREA_DETAILS_SUCCESS:
      return action.payload;
    case constants.FETCH_CB_CLUSTER_DETAILS_REQUEST:
      return {};
    default:
      return state;
  }
};

const cbThanaDetails = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_CB_THANA_DETAILS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  countryDetails,
  clusterDetails,
  areaDetails,
  cbThanaDetails,
  selectedState,
  filteringState
});

export const getAllCbClusters = state => {
  //TODO need to change regions to Clusters
  if (state.user.cku.leftSidebar.countryDetails.cb_clusters)
    return state.user.cku.leftSidebar.countryDetails.cb_clusters;
  return [];
};

export const getAllCbAreas = state => {
  //TODO need to change areas to kams
  if (state.user.cku.leftSidebar.clusterDetails.cb_areas)
    return state.user.cku.leftSidebar.clusterDetails.cb_areas;
  return [];
};

export const getAllCbThanas = state => {
  //TODO need to change territories to cb_upazilas
  if (state.user.cku.leftSidebar.areaDetails.cb_thanas)
    return state.user.cku.leftSidebar.areaDetails.cb_thanas;
  return [];
};

export const getCbCountryDetails = state => {
  return state.user.cku.leftSidebar.countryDetails;
};

export const getCbClusterDetails = state => {
  return state.user.cku.leftSidebar.clusterDetails;
};

export const getCbAreaDetails = state => {
  return state.user.cku.leftSidebar.areaDetails;
};

export const getCbThanaDetails = state => {
  return state.user.cku.leftSidebar.cbThanaDetails;
};

export const getSelectedState = state => {
  return state.user.cku.leftSidebar.selectedState;
};

export const getFilteringState = state => {
  return state.user.cku.leftSidebar.filteringState;
};
